import React, { createContext, useContext } from 'react';

import { useObjectState, UseObjectStateReturnType } from '@utils/hooks';

type TLoginStateContext = {
  email: string;
};

type TLoginContext = UseObjectStateReturnType<TLoginStateContext>;

const LoginContext = createContext<TLoginContext>({} as TLoginContext);

export const LoginContextProvider: CustomFC = ({ children }) => {
  const [state, setState] = useObjectState({
    email: '',
  });

  return <LoginContext.Provider value={[state, setState]}>{children}</LoginContext.Provider>;
};

export const useLoginContext = (): TLoginContext => useContext(LoginContext);
